import { ORGANIZATION_API_TYPE } from './organization/helpers';
import { USER_PREFERENCE_TYPE } from './user-preferences/helpers';
import { USER_TYPE } from './user/helpers';
/**
 * Check if an object is a UserPreference object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isUserPreference = (item) => item.type === USER_PREFERENCE_TYPE;
/**
 * Check if an object is a User object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isUser = (item) => item.type === USER_TYPE;
/**
 * Check if an object is an Organization object.
 *
 * @param item - The object to test.
 * @returns boolean
 */
export const isOrganization = (item) => item.type === ORGANIZATION_API_TYPE;
//# sourceMappingURL=type-guards.js.map